module.exports = __webpack_public_path__ + "img/ua.b1bbbf4b.svg";